import { render } from "./POSTerminal.vue?vue&type=template&id=5f5d2874&scoped=true"
import script from "./POSTerminal.vue?vue&type=script&lang=js"
export * from "./POSTerminal.vue?vue&type=script&lang=js"

import "./POSTerminal.vue?vue&type=style&index=0&id=5f5d2874&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f5d2874"]])

export default __exports__